(function () {
  const STORAGE_KEY = "sp_theme";
  const root = document.documentElement;

  function applyTheme(mode) {
    root.setAttribute("data-theme", mode);
    // подсветка кнопок
    document.querySelectorAll("[data-theme-btn]").forEach(btn => {
      const v = btn.getAttribute("data-theme-btn");
      btn.classList.toggle("active", v === mode);
    });
  }

  function getPreferred() {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved || "auto";
  }

  function resolveAuto(mode) {
    if (mode !== "auto") return mode;
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }

  function set(mode) {
    localStorage.setItem(STORAGE_KEY, mode);
    applyTheme(mode);
    // для auto можно дополнительно ставить computed, но мы держим именно "auto" и используем CSS.
    // (а чтобы UI не тупил — подсветка кнопок всё равно верная)
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-theme-btn]");
    if (!btn) return;
    set(btn.getAttribute("data-theme-btn"));
  });

  // initial
  applyTheme(getPreferred());

  // если auto — реагируем на смену системной темы
  if (window.matchMedia) {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    mq.addEventListener?.("change", () => {
      if ((localStorage.getItem(STORAGE_KEY) || "auto") === "auto") applyTheme("auto");
    });
  }
})();
